// extracted by mini-css-extract-plugin
export default {"customTreeBox":"CustomTree_customTreeBox__gnEcE"};